import {api, routes} from "@/plugins/axios";
import {defineStore} from "pinia";
import {ref} from "vue";

export const useProfileBuilder = defineStore('useProfileBuilder', function () {
    const loading = ref(false);

    const loadingTabs = ref(false);
    const loadingFields = ref(false);

    const tabs = ref([]);
    const selectedFields = ref([]);

    async function getTabs(organizationSlug) {
        loading.value = true;

        try {
            const response = await api.get(routes.profileBuilder.tabs.get(organizationSlug));

            tabs.value = response.data.data;

            return Promise.resolve(response.data)
        } catch (error) {
            console.log('here');
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function getTab(uid, organizationSlug) {
        loadingTabs.value = true;

        try {
            const response = await api.get(routes.profileBuilder.tabs.get(organizationSlug, uid));

            const index = tabs.value.findIndex(t => t.uid === uid);

            if (index !== -1) {
                tabs.value.splice(index, 1, response.data.data[0]);
            }

            return Promise.resolve(tabs)
        } catch (error) {
            console.error(error);
        } finally {
            loadingTabs.value = false;
        }
    }

    async function addTab(label = '', organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.tabs.add(organizationSlug), {label: label});

            tabs.value = [...tabs.value, response.data];

            return Promise.resolve(tabs)
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function updateTab(uid, payload, organizationSlug) {
        try {
            const response = await api.patch(routes.profileBuilder.tabs.update(organizationSlug, uid), payload);

            const index = tabs.value.findIndex(t => t.uid === uid);

            tabs.value[index] = response.data;

            return Promise.resolve(tabs)
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function addField(organizationSlug, payload, tabUid) {
        try {
            const response = await api.post(routes.profileBuilder.fields.addField(organizationSlug), payload);

            const index = tabs.value.findIndex(t => t.uid === tabUid);

            if (index !== -1) {
                tabs.value[index].fields.push(response.data);
            }

            return Promise.resolve(tabs)
        } catch (error) {
            return Promise.reject(error);
        }
    }

    async function reorderTabs(newOrder, organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.tabs.reorder(organizationSlug), newOrder);

            return Promise.resolve(response)
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        } finally {
            loading.value = false;
        }
    }

    function selectField(uid) {
        if(!selectedFields.value.includes(uid)) {
            selectedFields.value.push(uid);
        } else {
            const index = selectedFields.value.indexOf(uid);
            if (index > -1) {
                selectedFields.value.splice(index, 1);
            }
        }
    }

    async function reorderField(payload, organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.fields.reorder(organizationSlug), payload);

            return Promise.resolve(response)
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        } finally {
            loading.value = false;
        }
    }

    async function updateField(uid, payload, organizationSlug) {
        try {
            const response = await api.patch(routes.profileBuilder.fields.update(organizationSlug, uid), payload);

            for(let i = 0; i < tabs.value.length; i++) {
                const index = tabs.value[i].pb_fields.findIndex(f => f.uid === uid);
                if (index !== -1) {
                    tabs.value[i].pb_fields[index] = response.data;
                }
            }

            return Promise.resolve(response)
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    }

    async function deleteBulkFields(payload, organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.fields.bulkDelete(organizationSlug), payload);

            return Promise.resolve(response)
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    }

    async function bulkMoveFields(payload, organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.fields.bulkMove(organizationSlug), payload);

            return Promise.resolve(response)
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    }

    async function bulkUpdateFields(payload, organizationSlug) {
        try {
            const response = await api.post(routes.profileBuilder.fields.bulkUpdate(organizationSlug), payload);

            return Promise.resolve(response)
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    }

    async function deleteTab(uid, organizationSlug) {
        try {
            const response = await api.delete(routes.profileBuilder.tabs.delete(organizationSlug, uid));

            return Promise.resolve(response)
        } catch (error) {
            console.error(error);
        }
    }

    return {
        loading,
        loadingTabs,
        loadingFields,
        tabs,
        getTabs,
        getTab,
        addTab,
        updateTab,
        addField,
        reorderTabs,
        selectField,
        selectedFields,
        reorderField,
        updateField,
        deleteBulkFields,
        bulkMoveFields,
        bulkUpdateFields,
        deleteTab,
    }
});